// Copyright (c) 2016 Deere & Company

import Facets from './state/facets';
import ProductSearch from './components/product-search';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';
import reports from '../../routes/products/reports';

const getStateToBindToContainerProps = state => ({
    ...state.productSearch,
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    dealerRecommendationCount: state.dealerRecommendationsReducer.dealerRecommendations.totalElements,
    exportToExcel: state.exportToExcel,
    facets: new Facets({
        ...state.productSearch.facets,
        dealerAccountsFacet: {
            ...state.productSearch.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    highRentalDaysCount: state.productSearch.highRentalDays.highdayscount,
    machineStatusUpdateCount: state.machineStatusUpdate.machineStatusUpdates.length,
    registrationReviewCount: state.registrationReview.registrations.length,
    reportsRoutes: reports(),
    security: state.user.security,
    transferApprovalsCount: state.home.wip.productTracking.transferApprovals,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    queryParams: parentProps.location.query
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ProductSearch);




// WEBPACK FOOTER //
// ./src/product/search/state-connector.js